import Accordion from './Accordion';

export default Accordion;



// WEBPACK FOOTER //
// ./~/rp-react-common/src/Accordion/index.js